import request from '@/utils/request'

// 分页查询员工管理列表
export function paginationEmployee(query = {}, pagination) {
  return request({
    url: `/system/employee/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 不分页查询员工管理列表
export function listEmployee(query = {}) {
  return request({
    url: '/system/employee/list',
    method: 'post',
    data: query
  })
}

// 查询员工管理详细
export function getEmployee(employeeId) {
  return request({
    url: '/system/employee/info/' + employeeId,
    method: 'get'
  })
}

// 新增员工管理
export function addEmployee(data) {
  return request({
    url: '/system/employee/add',
    method: 'post',
    data: data
  })
}

// 修改员工管理
export function updateEmployee(data) {
  return request({
    url: '/system/employee/edit',
    method: 'put',
    data: data
  })
}

// 删除员工管理
export function delEmployee(employeeId) {
  return request({
    url: '/system/employee/remove/' + employeeId,
    method: 'delete'
  })
}
